import Link from 'next/link';
import { Briefcase, Layout, Award, Users } from 'lucide-react';

const BottomNavigation = () => {
  const navigationItems = [
    { title: 'Capabilities', icon: <Layout className="mb-2" />, href: '/capabilities' },
    { title: 'Industries', icon: <Users className="mb-2" />, href: '/capabilities#Industry' },
    { title: 'Success Stories', icon: <Award className="mb-2" />, href: '/blog/success-stories' },
    { title: 'Careers', icon: <Briefcase className="mb-2" />, href: '/career' }
  ];

  return (
    <div className="w-full max-w-6xl mx-auto pt-16 pb-0 px-4 mt-5">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
      {navigationItems.map((item) => (
                <a
                  key={item.title}
                  href={item.href}
                  className="group flex flex-col items-center p-4 rounded-lg transition-all duration-300 hover:bg-amber-50"
                >
                  <div className="text-gray-600 group-hover:text-[#F1AA4E]">
                    {item.icon}
                  </div>
                  <span className="text-gray-600 text-lg text-center font-medium group-hover:text-[#F1AA4E] mt-2">
                    {item.title}
                  </span>
                  <span className="mt-2 transform transition-transform duration-300 opacity-0 group-hover:opacity-100 group-hover:translate-x-2">
                    →
                  </span>
                </a>
        ))}
      </div>
    </div>
  );
};

export default BottomNavigation;
